import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Profile from './components/Profile';
import Social from './components/Social'
// import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
// import Resume from './components/Resume';
import Footer from './components/Footer';
// import Loader from "./components/Loader";
import './App.css';


function App() {
  return (
    <>
      {/* <div className="App">
        <Navbar/>
        <Profile/>
        <Social/>
        <About/>
      </div> */}
      {/* <Loader/> */}
    <Router>
      <Navbar/>
      <Social/>
      <Routes>
        <Route path="/" element={<Profile />} />
        {/* <Route path="/about" element={<About />} /> */}
        <Route path="/skills" element={<Skills />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        
        {/* <Route path="/resume" element={<Resume />} /> */}
      </Routes>
      <Footer/>
    </Router>
   </>
  );
}

export default App;
